/* Varukorgen för designade produkter:
   1) Tilläggsrader ("Extra tryck", property _for = designens id, _per = antal extra ytor) följer
      huvudraden: tas huvudraden bort försvinner tillägget, ändras antalet följer tillägget med.
      Raderna visas inte som egna rader – priset bakas in i huvudraden (Liquid i varukorgsmallarna).
   2) Designrader (snippets/mn-cart-design.liquid): förhandsbild av produkten med trycken, chips
      för varje vald tryckyta med kryss (tar bort ytans tryckfil ur ordern), "Ändra design". */
(function () {
  var busy = false;
  function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
  function getCart() { return fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function change(body) {
    return fetch(root() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
  }

  /* ---------- tilläggsrader ---------- */
  function sync() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var items = cart.items || [];
      var main = {};   /* variant-id och design-id → { qty, per } ; per (extra ytor) från huvudraden om den har det */
      items.forEach(function (it) {
        if (it.properties && it.properties._for) return;
        var perMain = it.properties && it.properties._per != null ? parseInt(it.properties._per, 10) : null;
        if (perMain != null && isNaN(perMain)) perMain = null;
        var mtMain = it.properties && it.properties._mt != null ? (it.properties._mt === '1' ? 1 : 0) : null;
        var keys = [String(it.variant_id)];
        if (it.properties && it.properties._design) keys.push(String(it.properties._design));
        keys.forEach(function (k) { var m = main[k] || { qty: 0, per: null, mt: null }; m.qty += it.quantity; if (perMain != null) m.per = perMain; if (mtMain != null) m.mt = mtMain; main[k] = m; });
      });
      var changes = [];
      items.forEach(function (it) {
        var f = it.properties && it.properties._for;
        if (!f) return;
        var m = main[String(f)];
        /* "Egen text på mall" (_typ mt): en per plagg så länge huvudraden har ändrad mallrubrik (_mt = 1) */
        if (it.properties._typ === 'mt') {
          var wantMt = m ? m.qty * (m.mt === 0 ? 0 : 1) : 0;
          if (wantMt !== it.quantity) changes.push({ id: it.key, quantity: wantMt });
          return;
        }
        var perRaw = parseInt((it.properties && it.properties._per) || '1', 10);
        var per = m && m.per != null ? m.per : (isNaN(perRaw) ? 1 : perRaw);   /* 0 = inga extra ytor kvar → raden tas bort */
        var want = (m ? m.qty : 0) * Math.max(0, per);
        if (want !== it.quantity) changes.push({ id: it.key, quantity: want });
      });
      /* Designrad med extra ytor (_per > 0) men ingen tilläggsrad alls: lägg till den. Händer om varan kom
         i varukorgen utan designerns köpväg; utan raden betalade kunden inte för ärmen/ryggen. Varianten
         ligger på huvudraden (_xv), annars standardvarianten för kläder. */
      var finns = {};
      items.forEach(function (it) { if (it.properties && it.properties._for) finns[String(it.properties._for) + (it.properties._typ === 'mt' ? '|mt' : '')] = 1; });
      var saknas = [];
      items.forEach(function (it) {
        var pr = it.properties || {};
        if (pr._for || !pr._design) return;
        var mtv = Number(pr._mtv || window.MN_MALLTEXT_V || 0);
        if (pr._mt === '1' && mtv && !finns[String(pr._design) + '|mt']) {
          finns[String(pr._design) + '|mt'] = 1;
          saknas.push({ id: mtv, quantity: it.quantity, properties: { _for: String(pr._design), _typ: 'mt', 'Gäller': it.product_title || '', 'Mall': String(pr.Mall || '').replace(/, egen text$/, '') } });
        }
        if (finns[String(pr._design)]) return;
        var per = parseInt(pr._per, 10);
        var xv = Number(pr._xv || window.MN_EXTRA_V || 0);
        if (!(per > 0) || !xv) return;
        finns[String(pr._design)] = 1;
        var ytor = []; try { ytor = JSON.parse(pr._ytor || '[]').slice(1).map(function (y) { return y.namn; }); } catch (e) { ytor = []; }
        saknas.push({ id: xv, quantity: it.quantity * per, properties: { _for: String(pr._design), _per: String(per), 'Gäller': it.product_title || '', 'Ytor': ytor.join(', ') } });
      });
      var run = Promise.resolve();
      changes.forEach(function (c) { run = run.then(function () { return change(c); }); });
      if (saknas.length) run = run.then(function () { return fetch(root() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ items: saknas }) }); });
      return run.then(function () { if (changes.length || saknas.length) refresh(); });
    }).catch(function () {}).finally(function () { busy = false; });
  }
  function refresh() {
    /* rita om lådan/varukorgssidan med Shopifys sektioner (varukorgssidans sektioner har mall-specifika id:n) */
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (x) { var el = document.getElementById(x); if (el && el.dataset.id) ids.push(el.dataset.id); });
    return fetch(root() + '?sections=' + ids.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sections) {
      Object.keys(sections).forEach(function (id) {
        var html = document.createElement('div'); html.innerHTML = sections[id];
        var src = html.querySelector('#shopify-section-' + id) || html.firstElementChild;
        var dst = document.getElementById('shopify-section-' + id);
        if (src && dst) dst.innerHTML = src.innerHTML;
        if (id === 'cart-drawer') { var d = document.querySelector('cart-drawer'); var s2 = html.querySelector('cart-drawer'); if (d && s2) d.innerHTML = s2.innerHTML; }
      });
      initLines();
    }).catch(function () {});
  }

  /* ---------- designrader ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function parse(el) {
    var d = {};
    try { d = JSON.parse(el.querySelector('[data-mn-line-data]').textContent) || {}; } catch (e) { d = {}; }
    var ytor = [];
    try { ytor = JSON.parse(el.dataset.ytor || '[]') || []; } catch (e) { ytor = []; }
    d.ytor = ytor; d.files = d.files || {}; delete d.files._;
    return d;
  }
  function initLines() {
    document.querySelectorAll('[data-mn-design-line]').forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';
      var d = parse(el);
      var row = el.closest('.cart-item');
      var img = row && row.querySelector('.cart-item__image');
      if (img) {
        if (el.dataset.preview) { img.srcset = ''; img.removeAttribute('sizes'); img.src = el.dataset.preview; }
        else renderFromFiles(el, d, img);
      }
      var host = el.querySelector('[data-mn-prints]');
      if (!host) return;
      if (d.ytor.length) {
        host.innerHTML = d.ytor.map(function (y) {
          return '<span class="mn-cart-print">' + esc(y.namn) +
            (d.ytor.length > 1 ? '<button type="button" data-mn-remove-print="' + esc(y.id) + '" title="Ta bort trycket på ' + esc(y.namn.toLowerCase()) + '" aria-label="Ta bort trycket på ' + esc(y.namn) + '">×</button>' : '') + '</span>';
        }).join('');
      } else if (el.dataset.tryck) {
        host.innerHTML = el.dataset.tryck.split(' + ').map(function (n) { return '<span class="mn-cart-print">' + esc(n) + '</span>'; }).join('');
      }
    });
  }
  /* ta bort en tryckyta direkt i varukorgen: egen tryckfil → properties uppdateras (tillägget följer via _per);
     delad tryckfil (kuddens fram/bak) → öppna designern */
  function removePrint(el, sid) {
    var d = parse(el);
    var y = d.ytor.find(function (x) { return x.id === sid; });
    if (!y) return;
    if (d.ytor.filter(function (x) { return x.fil === y.fil; }).length > 1) { location.href = el.dataset.edit + '&remove=' + encodeURIComponent(sid); return; }
    var btn = el.querySelector('[data-mn-remove-print="' + sid + '"]'); if (btn) btn.disabled = true;
    getCart().then(function (cart) {
      var it = (cart.items || []).find(function (x) { return x.key === el.dataset.key; });
      if (!it) return;
      var props = Object.assign({}, it.properties || {});
      var rest = d.ytor.filter(function (x) { return x.id !== sid; });
      if (y.fil === '_teckning') {
        /* huvudfilen försvinner: nästa yta blir huvudfil */
        var promote = rest.find(function (x) { return x.fil !== '_teckning'; });
        if (!promote) return;
        props._teckning = props[promote.fil]; delete props[promote.fil]; promote.fil = '_teckning';
      } else delete props[y.fil];
      props._ytor = JSON.stringify(rest);
      props.Tryck = rest.map(function (x) { return x.namn; }).join(' + ');
      props._per = String(Math.max(0, rest.length - 1));
      delete props._forhandsvisning;      /* förhandsbilden stämmer inte längre – ritas om från tryckfilerna */
      return change({ id: it.key, quantity: it.quantity, properties: props }).then(function () { return refresh(); }).then(function () { sync(); });
    }).catch(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mn-remove-print]');
    if (!b) return;
    e.preventDefault();
    removePrint(b.closest('[data-mn-design-line]'), b.dataset.mnRemovePrint);
  });

  /* ---------- förhandsbild från tryckfilerna (när ingen sparad förhandsbild finns) ---------- */
  var imgCache = {}, mapCache = {};
  function loadImg(src) {
    if (imgCache[src]) return imgCache[src];
    imgCache[src] = new Promise(function (resolve) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { resolve(im); }; im.onerror = function () { resolve(null); }; im.src = src; });
    return imgCache[src];
  }
  function loadMap(url) {
    if (mapCache[url]) return mapCache[url];
    mapCache[url] = loadImg(url).then(function (im) {
      if (!im) return null;
      var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
      var g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(im, 0, 0);
      var d = g.getImageData(0, 0, c.width, c.height).data, n = c.width * c.height;
      var u = new Uint16Array(n), v = new Uint16Array(n), ok = new Uint8Array(n);
      for (var i = 0, j = 0; i < n; i++, j += 4) { var r = d[j], gg = d[j + 1], b = d[j + 2]; if (!r && !gg && !b) continue; u[i] = (r << 4) | (b >> 4); v[i] = (gg << 4) | (b & 15); ok[i] = 1; }
      return { w: c.width, h: c.height, u: u, v: v, ok: ok };
    });
    return mapCache[url];
  }
  function renderFromFiles(el, d, img) {
    var ty = d.ty; if (!ty || d.gravyr) return;
    var color = el.dataset.color || '';
    var bilder = ty.bilder || {}, keys = Object.keys(bilder);
    var set = bilder[color] || bilder[''] || (keys.length ? bilder[keys[0]] : {}) || {};
    var first = keys.length ? bilder[keys[0]] : {};
    var groupOf = {};   /* property → tryckfil-grupp */
    (d.ytor || []).forEach(function (y) { groupOf[y.fil] = y.grupp; });
    var view = 'front';
    if (ty.v === 2 && d.ytor && d.ytor.length && ty.ytor && ty.ytor[d.ytor[0].id]) view = ty.ytor[d.ytor[0].id].vy;
    var base = set[view] || first[view] || set.front || first.front;
    if (!base) return;
    var SIZE = 360;
    loadImg(base).then(function (im) {
      if (!im) return;
      var W = SIZE, H = Math.round(SIZE * im.naturalHeight / im.naturalWidth);
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(im, 0, 0, W, H);
      if (ty.v === 2 && ty.vyer && ty.vyer[view]) {
        var kartor = ty.vyer[view].kartor || {};
        var jobs = Object.keys(d.files).map(function (prop) {
          var grupp = groupOf[prop] || (prop === '_teckning' ? 'front' : prop === '_teckning_rygg' ? 'back' : prop.replace('_teckning_', ''));
          var k = kartor[grupp]; if (!k) return null;
          return Promise.all([loadMap(k.url), loadImg(d.files[prop])]).then(function (r) { return { map: r[0], file: r[1] }; });
        }).filter(Boolean);
        return Promise.all(jobs).then(function (parts) {
          var out = g.getImageData(0, 0, W, H), p = out.data;
          /* skuggning: mockupens ljus normaliserat mot medianen inom trycket */
          var lum = new Float32Array(W * H), sample = [];
          for (var i = 0, j = 0; i < lum.length; i++, j += 4) lum[i] = 0.299 * p[j] + 0.587 * p[j + 1] + 0.114 * p[j + 2];
          parts.forEach(function (pt) {
            if (!pt.map) return;
            for (var y = 0; y < H; y += 2) for (var x = 0; x < W; x += 2) { var mi = Math.min(pt.map.h - 1, ((y + 0.5) / H * pt.map.h) | 0) * pt.map.w + Math.min(pt.map.w - 1, ((x + 0.5) / W * pt.map.w) | 0); if (pt.map.ok[mi]) sample.push(lum[y * W + x]); }
          });
          sample.sort(function (a, b) { return a - b; });
          var med = Math.max(12, sample[Math.floor(sample.length / 2)] || 200);
          parts.forEach(function (pt) {
            if (!pt.map || !pt.file) return;
            var fc = document.createElement('canvas'); var fw = Math.min(1200, pt.file.naturalWidth), fh = Math.round(fw * pt.file.naturalHeight / pt.file.naturalWidth);
            fc.width = fw; fc.height = fh; fc.getContext('2d').drawImage(pt.file, 0, 0, fw, fh);
            var fd = fc.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, fw, fh).data;
            var m = pt.map;
            for (var oy = 0; oy < H; oy++) for (var ox = 0; ox < W; ox++) {
              var mx = Math.min(m.w - 1, ((ox + 0.5) / W * m.w) | 0), my = Math.min(m.h - 1, ((oy + 0.5) / H * m.h) | 0), mi = my * m.w + mx;
              if (!m.ok[mi]) continue;
              var u = (m.u[mi] - 1) / 4094, v = (m.v[mi] - 1) / 4094;
              var fi = (Math.min(fh - 1, (v * fh) | 0) * fw + Math.min(fw - 1, (u * fw) | 0)) * 4;
              var a = fd[fi + 3] / 255; if (a < 0.01) continue;
              var s = Math.min(1.08, lum[oy * W + ox] / med), o = (oy * W + ox) * 4;
              p[o] = p[o] * (1 - a) + fd[fi] * s * a; p[o + 1] = p[o + 1] * (1 - a) + fd[fi + 1] * s * a; p[o + 2] = p[o + 2] * (1 - a) + fd[fi + 2] * s * a;
            }
          });
          g.putImageData(out, 0, 0);
          img.srcset = ''; img.removeAttribute('sizes'); img.src = c.toDataURL('image/jpeg', 0.85);
        });
      }
      /* äldre kalibrering: tryckfilen i rutan (platt) */
      var box = ty.front; var url = d.files._teckning;
      if (!box || !url) return;
      return loadImg(url).then(function (f) {
        if (!f) return;
        g.globalCompositeOperation = 'multiply';
        g.drawImage(f, box.l * W, box.t * H, box.w * W, box.h * H);
        img.srcset = ''; img.removeAttribute('sizes'); img.src = c.toDataURL('image/jpeg', 0.85);
      });
    }).catch(function () {});
  }

  /* ---------- din design i stort ----------
     Varukorgens bild är 100 px bred på mobil, och en design som ska tryckas
     på en tröja blir en prick i den storleken. Kunden ska kunna se exakt vad
     hon beställt innan hon betalar. Ett tryck på bilden, eller på knappen
     "Visa din design", öppnar förhandsbilden i full storlek.

     Bilden täcks i Dawn av en osynlig länk till produktsidan
     (.cart-item__link). På en designrad fångas klicket på den, eftersom
     produktsidan inte visar kundens design och kunden annars lämnar
     varukorgen utan att förstå varför. */
  var lada = null, fokusFore = null;
  function byggLada() {
    if (lada) return lada;
    lada = document.createElement('dialog');
    lada.className = 'mn-design-lada';
    lada.setAttribute('aria-labelledby', 'mn-design-lada-rubrik');
    lada.innerHTML =
      '<div class="mn-design-lada__kort">' +
        '<button type="button" class="mn-design-lada__stang" data-mn-lada-stang aria-label="Stäng">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<img class="mn-design-lada__bild" data-mn-lada-bild alt="">' +
        '<div class="mn-design-lada__text">' +
          '<p class="mn-design-lada__rubrik" id="mn-design-lada-rubrik" data-mn-lada-rubrik></p>' +
          '<p class="mn-design-lada__variant" data-mn-lada-variant></p>' +
        '</div>' +
        '<a class="mn-design-lada__andra" data-mn-lada-andra href="#"></a>' +
      '</div>';
    document.body.appendChild(lada);
    lada.addEventListener('click', function (e) {
      /* klick utanför kortet, alltså på bakgrunden, stänger */
      if (e.target === lada || e.target.closest('[data-mn-lada-stang]')) stangLada();
    });
    lada.addEventListener('close', function () {
      document.documentElement.classList.remove('mn-lada-oppen');
      if (fokusFore && document.contains(fokusFore)) fokusFore.focus({ preventScroll: true });
    });
    return lada;
  }
  function oppnaLada(el) {
    var row = el.closest('.cart-item');
    var img = row && row.querySelector('.cart-item__image');
    var src = (img && img.currentSrc) || (img && img.src) || el.dataset.preview;
    if (!src) return;
    var d = byggLada();
    var titel = (row.querySelector('.cart-item__name') || {}).textContent || '';
    var variant = Array.from(row.querySelectorAll('.product-option')).map(function (o) { return o.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean).join(', ');
    d.querySelector('[data-mn-lada-bild]').src = src;
    d.querySelector('[data-mn-lada-bild]').alt = el.dataset.ladaAlt || 'Din design';
    d.querySelector('[data-mn-lada-rubrik]').textContent = titel.trim();
    d.querySelector('[data-mn-lada-variant]').textContent = variant;
    d.querySelector('[data-mn-lada-variant]').hidden = !variant;
    var andra = d.querySelector('[data-mn-lada-andra]');
    andra.href = el.dataset.edit || '#';
    andra.textContent = el.dataset.ladaAndra || 'Ändra design';
    d.querySelector('[data-mn-lada-stang]').setAttribute('aria-label', el.dataset.ladaStang || 'Stäng');
    fokusFore = document.activeElement;
    document.documentElement.classList.add('mn-lada-oppen');
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    d.querySelector('[data-mn-lada-stang]').focus({ preventScroll: true });
  }
  function stangLada() {
    if (!lada) return;
    if (typeof lada.close === 'function' && lada.open) lada.close();
    else { lada.removeAttribute('open'); document.documentElement.classList.remove('mn-lada-oppen'); }
  }
  document.addEventListener('click', function (e) {
    var knapp = e.target.closest && e.target.closest('[data-mn-visa-design]');
    if (knapp) { e.preventDefault(); oppnaLada(knapp.closest('[data-mn-design-line]')); return; }
    /* den osynliga bildlänken på en designrad */
    var lank = e.target.closest && e.target.closest('.cart-item__link');
    if (!lank) return;
    var row = lank.closest('.cart-item');
    var el = row && row.querySelector('[data-mn-design-line]');
    if (!el) return;
    e.preventDefault();
    oppnaLada(el);
  });

  if (typeof window.subscribe === 'function') {
    window.subscribe('cart-update', function () { setTimeout(sync, 150); setTimeout(initLines, 200); });
  }
  document.addEventListener('DOMContentLoaded', function () { initLines(); setTimeout(sync, 800); });
  if (document.readyState !== 'loading') initLines();
  /* Dawn byter ut lådans/sidans innehåll vid varje ändring */
  var host = document.querySelector('cart-drawer, cart-items');
  if (host && 'MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(initLines, 60); }).observe(host, { childList: true, subtree: true });
  }
})();
